import * as React from "react";
import {FunctionComponent} from "react";
import {AppBar, Button, useTheme} from "@mui/material";
import Toolbar from "@mui/material/Toolbar";
import { useNavigate} from "react-router-dom";
import {AddCircle, CancelOutlined} from "@mui/icons-material";
import {useAppSelector} from "../../Config/Hooks";

import SaveIcon from "@mui/icons-material/Save";


interface Props {
    isOnSave?: boolean,
    systemRoutes: string,
    handleSave?: any,
    disableSave?: boolean
}

export const HeaderMenu: FunctionComponent<Props> = ({ isOnSave=false, handleSave, systemRoutes, disableSave=false}: Props) => {
    const isAuthenticated = useAppSelector((state: any) => state.authentication.isAuthenticated);
    const openMainMenu = useAppSelector((state: any) => state.layout.openMainMenu);
    const openSubMenu = useAppSelector((state: any) => state.layout.openSubMenu);
    const contentPagePaddingTop = useAppSelector((state: any) => state.layout.contentPagePaddingTop);

    const navigate = useNavigate();
    const theme = useTheme();

    const handleSaveMenu = () => {
        handleSave()
    }
    const isSmallScreen = window.innerWidth <= 400;
    const isMedianScreen = window.innerWidth <= 495;


    if (isAuthenticated ) return (
        <AppBar style={{paddingTop: isSmallScreen ? 96 : isMedianScreen ? 84 : contentPagePaddingTop}}>
            <Toolbar
                sx={{
                    marginLeft: {xs: "initial", md: isAuthenticated ? (
                            openSubMenu ? (
                                openMainMenu ? `${400}px` : `${80}px`
                            ) : (
                                openMainMenu ? `${80}px` : `${0}` // Set margin to 50 if submenu closed and main menu open
                            )
                        ) : 'initial'},
                    backgroundColor: theme.palette.background.default
                }}
            >
                {
                    !isOnSave  ?
                    <Button
                        size={"small"}
                        variant="contained"
                        // component={Link}
                        disabled={disableSave}
                        onClick={() => `${navigate(systemRoutes)}`}
                        endIcon={<AddCircle />}>
                        Novo
                    </Button>
                        :
                       <>
                           <Button
                               variant="contained"
                               size={"small"}
                               color={"primary"}
                               endIcon={<SaveIcon/>}
                               disabled={disableSave}
                               onClick={handleSaveMenu}
                           >
                               Salvar
                           </Button>
                           <Button
                               size={"small"}
                               variant={theme.palette.mode === 'light' ? "outlined" : "contained"}
                               onClick={() => `${navigate(systemRoutes)}`}
                               endIcon={<CancelOutlined />}
                               style={{marginLeft: 5}}
                           >
                               Cancelar
                           </Button>
                       </>
                }


            </Toolbar>
        </AppBar>
    );

    return null;
}